import { render, staticRenderFns } from "./before-after-summary.vue?vue&type=template&id=dbe8b23a&scoped=true"
import script from "./before-after-summary.vue?vue&type=script&lang=js"
export * from "./before-after-summary.vue?vue&type=script&lang=js"
import style0 from "./before-after-summary.vue?vue&type=style&index=0&id=dbe8b23a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbe8b23a",
  null
  
)

export default component.exports